import {get} from 'lodash/fp'
import cx from 'classnames'
import React, {Component} from 'react'

import Button from '../Button'

import './styles.css'

class ButtonAnswers extends Component {
  render() {
    const {question, answer, onChange} = this.props
    const {answers, variant} = question
    return (
      <div className="button-answers">
        {answers.map(ans => (
          <div
            className={cx("button-answer", variant)}
            key={ans.value}
          >
            <div className="button-answer-size">
              <Button
                className={cx("button-answer-btn", variant)}
                onClick={() => onChange(ans)}
                active={ans.value === get('value', answer)}
              >
                {ans.value}
              </Button>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default ButtonAnswers



// WEBPACK FOOTER //
// ./src/components/Question/ButtonAnswers.js